import numeral from 'numeral';
import moment from 'moment';
import {toWords} from 'number-to-words';

export const isValidEmail = email => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

export const isValidNumber = value => typeof value === 'number';

export const currencyFormatter = num => numeral(num).format('0,0.00');

export const numberLetterFormatter = num => numeral(num).format('0.0a');

export const formatDate = (date, format = 'MMM D, YYYY') => (date ? moment(date).format(format) : '');

export const convertNumToCurrencyWords = num => {
    const str = num.toString();
    const res = str.split('.');
    let words = '';
    if (res.length === 2) {
        words = `${toWords(res[0])} dollars and ${toWords(res[1])} cents`;
        return words;
    }
    words = `${toWords(res[0])} dollars`;
    return words;
};

export const convertNumToPercentageWords = num => {
    const str = num.toString();
    const res = str.split('.');
    let words = '';
    if (res.length === 2) {
        words = `${toWords(res[0])} point ${toWords(res[1])} percent`;
        return words;
    }
    words = `${toWords(res[0])} percent`;
    return words;
};
